import { CustomItem, FindParamsDefault } from '@domains';
import { createAction, props } from '@ngrx/store';

export enum CustomItemActionType {
  ClearCustomItemsFindParams = '[Captain] Clear Custom Items Find Params',
  ClearCustomItems = '[Captain] Clear Custom Items',
  GetCustomItems = '[Item] Get Custom Items',
  GetCustomItemsSuccess = '[Item] Get Custom Items Success',

  GetCustomItem = '[Item] Get Custom Item',
  GetCustomItemSuccess = '[Item] Get Custom Item Success',

  CreateCustomItem = '[Item] Create Custom Item',
  CreateCustomItemSuccess = '[Item] Create Custom Item Success',
  CreateCustomItemFail = '[Item] Create Custom Item Fail',

  UpdateCustomItem = '[Item] Update Custom Item',
  UpdateCustomItemSuccess = '[Item] Update Custom Item Success',
  UpdateCustomItemFail = '[Item] Update Custom Item Fail',

  DeleteCustomItem = '[Item] Delete Custom Item',
  DeleteCustomItemSuccess = '[Item] Delete Custom Item Success',

  RestoreCustomItem = '[Item] Restore Custom Item',
  RestoreCustomItemSuccess = '[Item] Restore Custom Item Success',
}

export const clearCustomItemsFindParams = createAction(CustomItemActionType.ClearCustomItemsFindParams);
export const clearCustomItems = createAction(CustomItemActionType.ClearCustomItems);
export const getCustomItems = createAction(CustomItemActionType.GetCustomItems, props<{ findParams: FindParamsDefault; keep?: boolean }>());
export const getCustomItemsSuccess = createAction(
  CustomItemActionType.GetCustomItemsSuccess,
  props<{
    resultsCount: number;
    results: Array<CustomItem>;
  }>(),
);

export const getCustomItem = createAction(CustomItemActionType.GetCustomItem, props<{ id: string; expand?: string[] }>());
export const getCustomItemSuccess = createAction(CustomItemActionType.GetCustomItemSuccess, props<{ item: CustomItem }>());

export const createCustomItem = createAction(CustomItemActionType.CreateCustomItem, props<{ item: CustomItem }>());
export const createCustomItemSuccess = createAction(CustomItemActionType.CreateCustomItemSuccess, props<{ item: CustomItem }>());
export const createCustomItemFail = createAction(CustomItemActionType.CreateCustomItemFail);

export const updateCustomItem = createAction(CustomItemActionType.UpdateCustomItem, props<{ item: CustomItem }>());
export const updateCustomItemSuccess = createAction(CustomItemActionType.UpdateCustomItemSuccess, props<{ item: CustomItem }>());
export const updateCustomItemFail = createAction(CustomItemActionType.UpdateCustomItemFail);

export const deleteCustomItem = createAction(CustomItemActionType.DeleteCustomItem, props<{ itemId: string }>());
export const deleteCustomItemSuccess = createAction(CustomItemActionType.DeleteCustomItemSuccess, props<{ itemId: string }>());

export const restoreCustomItem = createAction(CustomItemActionType.RestoreCustomItem, props<{ itemId: string }>());
export const restoreCustomItemSuccess = createAction(CustomItemActionType.RestoreCustomItemSuccess, props<{ itemId: string }>());
